<template>
  <!-- some code condensed for display reasons -->
  <center>
  <FormulateForm v-model="values" @submit="submitHandler">
    <h2>Beach Crew</h2>
    <FormulateInput
      type="group"
      name="userdata"
      label=" Registration"
    
      validation="required"
    >
          <FormulateInput name="firstname" type="text" label="First Name"  />
    <FormulateInput name="orderNotes" type="text" label="Last Name"  />
    <FormulateInput name="orderNotes" type="text" label="Street Address"  />
 <FormulateInput name="orderNotes" type="text" label="City"  />
  <FormulateInput name="orderNotes" type="text" label="State"  />
<FormulateInput
  type="number"
  name="zip"
  label="Zip Code"
  placeholder="Zip Code"
  validation="number"
  min="0"
  max="100"
  error-behavior="live"
/>        <FormulateInput
  type="email"
  label="What is your  email address?"
  validation="email"

 
/>
        <FormulateInput name="os" type="select" label="Phone OS" validation="required" :options="{ android: 'Android', iphone: 'iPhone', na: 'N/A'}" />
      
  <FormulateInput
  type="tel"
  name="phone"
  label="Phone Number"
  placeholder="phone #"
  
  validation="required"
/>

    </FormulateInput>

    <FormulateInput name="age" type="radio" label="Are you 18 years or older?" validation="required" :options="{ yes: 'Yes', no: 'No (5-mile radius)' }" />
    <FormulateInput name="areas" type="textarea" label="Preferred areas to clean-up?"  />
   
       <FormulateInput name="organize" type="radio" label="Would you like to organize a clean-up with friends or neighbors?" validation="required" :options="{ cleanupyes: 'Yes', cleanupno: 'No' }" />
 <FormulateInput name="changes" type="textarea" label="What changes at the lake would help reduce our trash? "  />
   
    <FormulateInput type="submit" value="Submit" />
    <pre>{{  }}</pre>
  </FormulateForm>
  </center>
</template>

<script>
export default { data () { return { values: {} } }, methods: {submitHandler () { alert(`Thank you for signing up!`) } } }
</script>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
